import React from 'react';
import { branch, renderComponent, renderNothing } from 'recompose';
import { Icon } from 'js/components/common/Icon';
import { usePortletTranslations } from 'js/components/system/Portlet';
import Empty from './Empty';
import TableDumb from './Table';
import style from './index.scss';

export const Title = ({ text }) => (
    <div className={style.title}>
        <Icon className={style.titleIcon} type="leaderboard" />
        <span className={style.titleText}>{text}</span>
    </div>
);

export const Table = branch(
    ({ competitorsTable = [] }) => competitorsTable.length > 0,
    renderComponent(TableDumb)
)(Empty);

export const CompetitorsTable = ({ useRoundsTitle, onCompetitorClicked, className = '', displayTitle, minPointsForPrizeIssue, competitorsTable, leaderboardId, useTournament, joined, registrationStatus, showPrizes = true, status, participantsCount, prizes, showRankPrizes }) => {
    const t = usePortletTranslations();
    return (
        <div className={`${style.container} ${className}`}>
            {displayTitle && <Title text={t('competitorsTable.title')} />}
            <Table {...{ onCompetitorClicked, useRoundsTitle, competitorsTable, leaderboardId, useTournament, joined,
                registrationStatus, minPointsForPrizeIssue, showPrizes, status, participantsCount, prizes, showRankPrizes }} />
        </div>
    );
};

export default branch(
    ({ displayTable = true }) => !displayTable,
    renderNothing
)(CompetitorsTable);
